import React from "react";
import { Check } from "lucide-react";

const tiers = [
  {
    name: "Kiszállás",
    price: "8.000",
    unit: "Ft / alkalom",
    desc: "Tápióbicskéről 50 km-en belül ingyenes. Távolabb km díj.",
    items: ["Helyszíni felmérés", "Hibafelderítés", "Árajánlat készítése"],
  },
  {
    name: "Óradíj",
    price: "12.500",
    unit: "Ft / óra",
    desc: "Standard szerelési munkák.",
    items: ["Munkadíj", "Alapanyag külön", "Számlás"],
    highlight: true,
  },
  {
    name: "0-24 sürgősségi",
    price: "+50%",
    unit: "felár",
    desc: "Éjszaka, hétvége, ünnepnap.",
    items: ["30 percen belüli visszahívás", "1-3 órán belüli kiérkezés 100 km körzetben", "Garantált hibaelhárítás"],
  },
];

export default function Pricing() {
  return (
    <section id="arak" data-testid="pricing-section" className="border-b border-[#262626] bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
          [ 05 / Árazás ]
        </div>
        <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none mb-4">
          Átlátható <span className="text-[#FFD700]">áron.</span>
        </h2>
        <p className="text-[#A3A3A3] mb-12 max-w-2xl">
          Nincs rejtett költség. Előre kiadott írásos árajánlat. ÁFA-s számla minden esetben.
          Az árak tájékoztató jellegűek — pontos kalkulációért használja az AI Árkalkulátort vagy kérjen ajánlatot.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiers.map((t, i) => (
            <div
              key={i}
              data-testid={`pricing-tier-${i}`}
              className={t.highlight ? "card-hi" : "card"}
            >
              <div className="font-mono text-xs uppercase tracking-widest text-[#FFD700] mb-2">
                {t.name}
              </div>
              <div className="flex items-baseline gap-2 mb-1">
                <span className="font-heading text-5xl text-white">{t.price}</span>
                <span className="font-mono text-sm text-[#A3A3A3]">{t.unit}</span>
              </div>
              <p className="text-sm text-[#A3A3A3] mb-6">{t.desc}</p>
              <ul className="space-y-2 mb-6">
                {t.items.map((it, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm font-mono">
                    <Check className="w-4 h-4 text-[#FFD700] mt-0.5 shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
              <a href="#kapcsolat" data-testid={`pricing-cta-${i}`} className="btn-primary w-full justify-center">
                Ajánlat kérése
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
